import classNames from 'classnames';
import * as React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import css from './BooksCompleteAlert.module.scss';

interface Props {
  className?: string;
}

const BooksCompleteAlert = ({ className }: Props) => {
  const classes = classNames(css.BooksCompleteAlert, className);
  const intl = useIntl();

  return (
    <div className={classes}>
      <span className={css.BooksCompleteAlert__Title}>
        {intl.formatMessage({ id: 'books.forms.completeAlertTitle' })}
      </span>
      <span className={css.BooksCompleteAlert__Text}>
        <FormattedMessage
          id="books.forms.completeAlertText"
          values={{
            link: (
              <span className={css.BooksCompleteAlert__Emphasis}>
                {intl.formatMessage({ id: 'books.forms.bookingList' })}
              </span>
            ),
          }}
        />
      </span>
    </div>
  );
};

export default BooksCompleteAlert;
